import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Wizard of Oz",
  "description": "",
  "published": "2007-03-28T00:00:00.000Z",
  "redirect_from": ["/blog/the-wizard-of-oz/swizec/251"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I often watch films not for what the cast is or the special effects or even the story but rather for what they sound like, don't really know what it is about sound in films and videos that captivates me as much as it does. So imagine my surprise last night when I accidentally flip over to TCM and am greeted by one of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/The_Wizard_of_Oz_(1939_film)"
      }}>{`the best sounding films of all time`}</a>{`. Oh I've been singing songs from it to myself ever since!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      